import { getWindow } from '@cap/ssr-common-utils';
import { useParams, useLocation } from 'react-router-dom';

/**
 * 
 * @returns 
  const { params, queryParams } = useRouteParams();
  const tenant = params.tenant;
  const userId = queryParams.get('userId');  // 从查询参数获取 userId
  liuhuasen
 */
const useRouteParams = () => {
  interface RouteParams {
    [key: string]: string;
  }

  const params = useParams<RouteParams>();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  return {
    params,
    queryParams,
    pathname: location.pathname, // 当前路径
    search: location.search, // 查询字符串部分（例如 `?key=value`）
    hash: location.hash, // 哈希部分（例如 `#section`）
    state: location.state, // 路由状态，通常用于通过 `navigate` 跳转时传递的状态
    fullUrl: getWindow().location.href, // 完整的 URL
  };
};

export default useRouteParams;
